import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const FacilityIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M9.1094 1.125C9.1094 0.501562 9.59305 0 10.1942 0H12.0023H13.8103C14.4115 0 14.8951 0.501562 14.8951 1.125C14.8951 1.74844 14.4115 2.25 13.8103 2.25H13.0871V4.5H14.8951C15.6952 4.5 16.3415 5.17031 16.3415 6H20.5543C21.5216 6 22.2176 6.97031 21.9374 7.93125L20.0796 14.3672C20.4367 14.55 20.6808 14.9344 20.6808 15.375C20.6808 15.9984 20.1972 16.5 19.596 16.5H18.5112V22.875C18.5112 23.4984 18.0275 24 17.4264 24C16.8252 24 16.3415 23.4984 16.3415 22.875V16.5H7.66297V22.875C7.66297 23.4984 7.17932 24 6.57815 24C5.97698 24 5.49333 23.4984 5.49333 22.875V16.5H4.40851C3.80733 16.5 3.32368 15.9984 3.32368 15.375C3.32368 14.9344 3.56777 14.55 3.92486 14.3672L2.06258 7.93125C1.78234 6.97031 2.47843 6 3.45025 6H7.66297C7.66297 5.17031 8.30934 4.5 9.1094 4.5H10.9174V2.25H10.1942C9.59305 2.25 9.1094 1.74844 9.1094 1.125ZM6.15778 14.25H7.66297V8.25H4.42207L6.15778 14.25ZM9.83261 14.25H14.1719V8.25H9.83261V14.25ZM16.3415 8.25V14.25H17.8467L19.5824 8.25H16.3415Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default FacilityIcon
